import { UserVirtualOfficeLicence } from '../views/Settings/settings.types';

export interface User {
  id: number;
  referrerId: number;
  phoneNumber: string;
  email: string;
  registrationStatus: number;
  profileImageUrl: string;
  name: string;
  username: string;
  surname: string;
  genderType: number;
  dateOfBirth: string;
  country: string;
  countryCode: string;
  creationType: number;
  isEmailVerified: boolean;
  isPhoneNumberVerified: boolean;
  userTickets: UserTicketsModel;
  currentVirtualOfficeLicence:
    | VirtualOfficeLicenceModel
    | UserVirtualOfficeLicence
    | null;
  referralCode: string;
}

export interface VirtualOfficeLicenceModel {
  licenceId: number;
  dateEnd: string;
  licenceName?: string;
}

export interface UserTicketsModel {
  shoppingPoints: number;
  donationPoints: number;
  comissionPercent: number;
  pendingRewardPoints: number;
  availableRewardPoints: number;
  givvoPoints: number;
  ulxPoints: number;
  loyaltyPoints: number;
  myLifePoints: number;
}

interface Token {
  refreshToken: string;
  accessToken: string;
  accessTokenExpiry: string;
}

interface KYCStatus {
  isAddressAdded: boolean;
  isWalletAdded: boolean;
  isDocumentAdded: boolean;
  isSelfieAdded: boolean;
  isKycCompleted: boolean;
  isAllCompleted: boolean;
  selfieImageUrl: string;
  documentImageUrls: string[];
  documentType: number;
  documentHolder: string;
  isKycVerified: boolean;
  arePersonalDetailsAdded: boolean;
  areTermsAccepted: boolean;
}

export interface UserInfoType {
  user: User;
  referrer: {
    id: number;
    name: string;
    surname: string;
  };
  token: Token;
  kycStatus: KYCStatus;
  unseenNotificationCount: number;
  unseenMessageCount: number;
  unseenSupportMessageCount: number;
  isFirstLoginPopupChecked: boolean;
  isSideModalChecked: boolean;
  isX1KycRegistered: boolean;
  userType: number;
  isCanadaRestrictedUser: boolean;
  canBuyBigWhale: boolean;
  canBuyTravelPackages: boolean;
  canBuyStakingPackages: boolean;
  isJapanRestrictedUser: boolean;
  canBuyFlipMePackages: boolean;
  canBuyAkashaPackages: boolean;
  isMavieMigrationModalChecked: boolean;
}
export interface SignInType {
  email: string;
  password: string;
  result: any;
  history: any;

  finup?: any;
  finupTest?: any;
  simplicity?: any;
  simplicityRedirectUri?: any;
}

export interface SignInGoogleType {
  token: string;
  referrerId: number;
  captchaResult: any;
  history: any;

  finup?: any;
  finupTest?: any;
  simplicity?: any;
  simplicityRedirectUri?: any;
}

export interface SignInCompleteType {
  signInToken: string;
  emailCode: string | null;
  twoFAcode: string | null;
  is2FARequired: boolean;
  history: any;
  finup?: any;
  finupTest?: any;
  simplicity?: any;
  simplicityRedirectUri?: any;
}

export interface RegisterType {
  referrerId?: number;
  token?: string;
  user?: any;
  path?: string;
  approvalDate?: string;
  referrer?: {
    name: string;
    surname: string;
  };
}

export interface SignInResponseType {
  is2FARequired: boolean;
  isEmailCodeVerificationRequired: boolean;
  signInToken: string;
  user: User;
}

export interface authInitialStateType {
  userInfo: UserInfoType;
  loading: boolean;
  register: RegisterType;
  signIn?: SignInResponseType;
}

export enum RegistrationStatus {
  EmailVerification = 3,
  EmailVerified = 4,
  PasswordAdded = 5,
  SocialNetworkCreation = 6,
  SocialNetworkReferrerAdded = 7,
  TeamAdding = 10,
  ProfileDetailsAdded = 11,
  SocialNetworkProfileDetailsAdded = 12,
  SocialNetworkTermsAndConditionsAccepted = 13
}

export enum CreationTypes {
  Local = 1,
  Google = 4
}

export enum UserTypes {
  Regular = 1,
  Restricted = 2
}
